import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { initializeAnalytics } from './services/GAService'

initializeAnalytics();
ReactDOM.render(<App />, document.getElementById("splash2"));
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit

document.body.addEventListener("touchmove", (e)=>{
  e.preventDefault()
})


